/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 */

/**
 * @author Satyaki Bose
 * syllabusInitialState.js
 * Initial state definition for syllabus context
 */

// Initial state
const initialState = {
  // File management
  uploadedFile: null,
  isDragActive: false,

  // Upload state
  isUploading: false,
  progress: 0,
  uploadId: null,
  uploadError: null,

  // Syllabus data
  syllabusInfo: null,
  assignments: [],

  // UI state
  tabValue: 0,

  // Date adjustment parameters for bulk edit
  dateAdjustParams: null,

  // Last assignment defaults
  assignmentDefaults: null
};

export default initialState;
